import { render, staticRenderFns } from "./BtnAtualizarComissionamento.vue?vue&type=template&id=5e39c854"
import script from "./BtnAtualizarComissionamento.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarComissionamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports